import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { APIService } from '@/services/APIService';

export class api_management extends APIService {
  constructor(api_base_url, is_dummy = false) {
    super(api_base_url);
    // this.is_dummy = true;
  }
  getSuggestedExperimentLabManual(experiment) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSuggestedExperimentLabManual.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          experiment: experiment,
        }
      }).then(response => response.data);
    }
  }
  getExperimentSetLabManual(school_id, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getExperimentSetLabManual.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getExperimentSetPhoto(school_id, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getExperimentSetPhoto.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getSuggestedExperimentPhoto(experiment) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSuggestedExperimentPhoto.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          experiment: experiment,
        }
      }).then(response => response.data);
    }
  }
  getSchoolEquipmentCommandList(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolEquipmentCommandList.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id
        }
      }).then(response => response.data);
    }
  }
  applySchoolExperimentChange(school_id, experiment, equipment_id, status, c1check, c1, c2check, c2){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/applySchoolExperimentChange.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('status', status);
    if(c1check==true) {
      bodyFormData.set('c1check', c1check);
      bodyFormData.set('c1', c1);
    }
    if(c2check==true) {
      bodyFormData.set('c2check', c2check);
      bodyFormData.set('c2', c2);
    }
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  resetUserPassword(school_id, username, new_password){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/resetUserPassword.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('username', username);
    bodyFormData.set('new_password', new_password);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  addInchargeAccount(school_id, username,password, email, created_by, auth_token){
    var self = this;
    console.log(created_by);
    const url = `${this.api_base_url}/api/iot/management/addInchargeAccount.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('username', username);
    bodyFormData.set('password', password);
    bodyFormData.set('email', email);
    bodyFormData.set('created_by', created_by);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  addNewSchool(school_id, school_name, school_chi_name, username, auth_token) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/addNewSchool.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('school_name', school_name);
    bodyFormData.set('school_chi_name', school_chi_name);
    bodyFormData.set('username', username);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getExperimentList() {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getExperimentList.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
        }
      }).then(response => response.data);
    }
  }
  addNewExperiment(experiment, experiment_name, field, username, auth_token) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/addNewExperiment.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('experiment_name', experiment_name);
    bodyFormData.set('field', field);
    bodyFormData.set('username', username);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getSchoolList() {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolList.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
        }
      }).then(response => response.data);
    }
  }
  getSchoolOpenedExperiment(school_id, show_all=false) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolOpenedExperiment.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          show_all: show_all
        }
      }).then(response => response.data);
    }
  }
  getSchoolExperiment(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolExperiment.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id
        }
      }).then(response => response.data);
    }
  }  
  getSchoolGroupExperiment(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolGroupExperiment.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id
        }
      }).then(response => response.data);
    }
  }
  getSchoolFromSchoolList(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolFromSchoolList.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id
        }
      }).then(response => response.data);
    }
  }
  getBookSlotsBySchool(school_id, experiment=null, equipment_id=null, date_from=null, date_to=null, status=null) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getBookSlotsBySchool.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id,
          date_from: date_from,
          date_to: date_to,
          status: status,
        }
      }).then(response => response.data);
    }
  }
  getGroupExperimentSlotsBySchool(school_id, experiment=null, equipment_id=null, date_from=null, date_to=null, status=null) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getGroupExperimentSlotsBySchool.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id,
          date_from: date_from,
          date_to: date_to,
          status: status,
        }
      }).then(response => response.data);
    }
  }  
  getGroupExperimentSlotInfo(school_id, ref) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getGroupExperimentSlotInfo.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          ref: ref,
        }
      }).then(response => response.data);
    }
  }
  getWeekBookings(school_id, experiment, equipment_id, from, to) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getWeekBookings.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id,
          from: from,
          to: to,
        }
      }).then(response => response.data);
    }
  }
  getUsersByUserGroup(school_id, group) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getUsersByUserGroup.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          group: group,
        }
      }).then(response => response.data);
    }
  }
  getSchoolUserGroups(school_id, status="ACTIVE") {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolUserGroups.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          status: status,
        }
      }).then(response => response.data);
    }
  }
  getSchoolUserGroupsGuest(school_id, status="ACTIVE", user_level) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolUserGroupsGuest.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          status: status,
          user_level: user_level,
        }
      }).then(response => response.data);
    }
  }
  getUsersBySchool(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getUsersBySchool.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
        }
      }).then(response => response.data);
    }
  }
  removeUserFromUserGroup(username, user_group){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/removeUserFromUserGroup.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('username', username);
    bodyFormData.set('user_group', user_group);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  removeUserGroupFromBookSlot(school_id, user_group, slot){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/removeUserGroupFromBookSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('user_group', user_group);
    bodyFormData.set('slot', slot);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getImportUserTemplate() {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getImportUserTemplate.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
        }
      }).then(response => response.data);
    }
  }
  importUsers(school, group, file) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/importUsers.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('group', group);
    bodyFormData.set('file', file);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getSchoolBookings(school_id, ref) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolBookings.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          ref: ref
        }
      }).then(response => response.data);
    }
  }
  createBookSlots(school, experiment, equipment_id, start_date, end_date, open_time, close_time, duration, prepare_time, groups, username) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/createBookSlots.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('start_date', start_date);
    bodyFormData.set('end_date', end_date);
    bodyFormData.set('open_time', open_time);
    bodyFormData.set('close_time', close_time);
    bodyFormData.set('period_time', duration);
    bodyFormData.set('prepare_time', prepare_time);
    bodyFormData.set('groups', groups);
    bodyFormData.set('username', username);

    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  assignGroupsToBookSlot(school, group, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/assignGroupsToBookSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('group', group);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }  
  createGroupExperiment(school, experiment, equipment_id, start_datetime, end_datetime, groups, username) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/createGroupExperiment.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('start_datetime', start_datetime);
    bodyFormData.set('end_datetime', end_datetime);
    bodyFormData.set('groups', groups);
    bodyFormData.set('username', username);

    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getSchoolOngoingBookSlots(school_id, user_group, groups) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolOngoingBookSlots.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          user_group: user_group,
          groups: groups
        }
      }).then(response => response.data);
    }
  }
  getSchoolInfo(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolInfo.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id
        }
      }).then(response => response.data);
    }
  }
  getSchoolExperimentInfo(school_id, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolExperimentInfo.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id,
        }
      }).then(response => response.data);
    }
  }
  assignGroupToBookSlot(school, user_group, ids) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/assignGroupToBookSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('user_group', user_group);
    bodyFormData.set('ids', ids);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  clearUserGroup(user_group) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/clearUserGroup.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('user_group', user_group);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  uploadLogoToServer(school_id, file, cb) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/uploadLogoToServer.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('file', file);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .then(response => response.data);
  }
  removeSchoolLogo(school_id, cb) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/removeSchoolLogo.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .then(response => response.data);
  }
  lockBooking(school, id, status) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/lockBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  unlockBooking(school, id, status) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/unlockBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  lockBookSlot(school, id, hold) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/lockBookSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('id', id);
    bodyFormData.set('hold', hold);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  unlockBookSlot(school, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/unlockBookSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  setMaintenanceBooking(school, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/setMaintenanceBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  unsetMaintenanceBooking(school, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/unsetMaintenanceBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  cancelBookSlot(school, slot_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/cancelBookSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('slot_id', slot_id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  cancelBooking(school, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/cancelBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  undoCancelBooking(school, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/undoCancelBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  
  addSchoolExperiment(school, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/addSchoolExperiment.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  uploadDocument(document, file, username, auth_token) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/uploadDocument.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('document', document);
    bodyFormData.set('file', file);
    bodyFormData.set('username', username);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }  
  uploadSuggestedExperimentLabManual(experiment, file, username, auth_token, language) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/uploadSuggestedExperimentLabManual.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('file', file);
    bodyFormData.set('username', username);
    bodyFormData.set('auth_token', auth_token);
    bodyFormData.set('language', language);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }  
  removeSuggestedExperimentLabManual(experiment) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/removeSuggestedExperimentLabManual.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('experiment', experiment);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  uploadSchoolExperimentLabManual(school_id, experiment, equipment_id, file, language) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/uploadSchoolExperimentLabManual.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('file', file);
    bodyFormData.set('language', language);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  removeSchoolExperimentLabManual(school_id, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/removeSchoolExperimentLabManual.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }  
  uploadSchoolExperimentPhoto(school_id, experiment, equipment_id, files) {
    var self = this;

    let totalfiles = files.length;
    var bodyFormData = new FormData();

    for (let index = 0; index < totalfiles; index++) {
      bodyFormData.append("files[]", files[index]);
    }
    const url = `${this.api_base_url}/api/iot/management/uploadSchoolExperimentPhoto.php`;
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  removeSchoolExperimentPhoto(school_id, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/removeSchoolExperimentPhoto.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  
  uploadSuggestedExperimentPhoto(experiment, files, username, auth_token) {
    var self = this;    

    let totalfiles = files.length;
    var bodyFormData = new FormData();

    for (let index = 0; index < totalfiles; index++) {
      bodyFormData.append("files[]", files[index]);
    }
    const url = `${this.api_base_url}/api/iot/management/uploadSuggestedExperimentPhoto.php`;
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('username', username);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  removeSuggestedExperimentPhoto(experiment) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/removeSuggestedExperimentPhoto.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('experiment', experiment);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getLastEquipment(school, experiment) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getLastEquipment.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school,
          experiment: experiment
        }
      }).then(response => response.data);
    }
  }  
  getSchoolGroupAssignments(school_id, group, host) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolGroupAssignments.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          group: group,
          host: host
        }
      }).then(response => response.data);
    }
  }  
  addSchoolUserGroup(school, group, host) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/addSchoolUserGroup.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('group', group);
    bodyFormData.set('host', host);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }  
  addSchoolUsers(school, group, file) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/addSchoolUsers.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('group', group);
    bodyFormData.set('file', file);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }  
  getSchoolAnnouncementManagement(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSchoolAnnouncementManagement.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
        }
      }).then(response => response.data);
    }
  }
  addSchoolAnnouncement(school_id, priority, value_en, value_ch, end_date, username, auth_token){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/addSchoolAnnouncement.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('priority', priority);
    bodyFormData.set('value_en', value_en);
    bodyFormData.set('value_ch', value_ch);
    bodyFormData.set('end_date', end_date);
    bodyFormData.set('username', username);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  applySchoolAnnouncementChange(school_id, priority, value_en, value_ch, end_date, ref, username, auth_token){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/applySchoolAnnouncementChange.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('priority', priority);
    bodyFormData.set('value_en', value_en);
    bodyFormData.set('value_ch', value_ch);
    bodyFormData.set('end_date', end_date);
    bodyFormData.set('ref', ref);
    bodyFormData.set('username', username);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getSystemAnnouncementManagement(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getSystemAnnouncementManagement.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
        }
      }).then(response => response.data);
    }
  }
  addSystemAnnouncement(school_id, priority, value_en, value_ch, end_date, username, auth_token){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/addSystemAnnouncement.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('priority', priority);
    bodyFormData.set('value_en', value_en);
    bodyFormData.set('value_ch', value_ch);
    bodyFormData.set('end_date', end_date);
    bodyFormData.set('username', username);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  applySystemAnnouncementChange(school_id, priority, value_en, value_ch, end_date, ref, username, auth_token){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/applySystemAnnouncementChange.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('priority', priority);
    bodyFormData.set('value_en', value_en);
    bodyFormData.set('value_ch', value_ch);
    bodyFormData.set('end_date', end_date);
    bodyFormData.set('ref', ref);
    bodyFormData.set('username', username);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getUserDailyBookingByExperiment(school_id, username, experiment, equipment_id, date){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getUserDailyBookingByExperiment.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          username: username,
          experiment: experiment,
          equipment_id: equipment_id,
          date: date,
        }
      }).then(response => response.data);
    }
  }
  returnBooking(school, username, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/returnBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('username', username);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  inactiveUserGroup(school_id, user_group){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/inactiveUserGroup.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('user_group', user_group);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  activeUserGroup(school_id, user_group){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/activeUserGroup.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('user_group', user_group);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getAllCurrentBookings(){
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/getAllCurrentBookings.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
        }
      }).then(response => response.data);
    }
  }
  editGroupExperimentConfig(school_id, experiment, equipment_id, ref, value="") {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/editGroupExperimentConfig.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('ref', ref);
    bodyFormData.set('value', value);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }  
  cancelGroupExperiment(school, slot_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/cancelGroupExperiment.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('slot_id', slot_id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
}